import { css } from '@linaria/core';
import { styled } from '@linaria/react';
import { COLORS, typographyStyles } from '@livecommerce/design-system';
import { Flair } from 'components-v3/Flairs/Flair.jsx';
import NumberIndicator from 'components-v3/NumberIndicator/index.jsx';

const { getBodyText } = typographyStyles;

export const IconWrapper = styled.div`
  display: flex;
  padding: 12px;
  border-radius: 4px;
`;

export const CustomIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: ${(props) => `${props.padding}px`};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  position: relative;
`;

export const navigationBaseStyles = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 8px;
  color: ${COLORS.white};
  transition: background-color 0.2s ease-in-out;
  position: relative;
  ${getBodyText(12, 500)};

  &:focus-visible,
  &:hover {
    & > ${CustomIconWrapper},
    & > ${IconWrapper}  {
      background-color: ${COLORS.dark_600};
    }
  }
  &.active {
    & > ${CustomIconWrapper},
    & > ${IconWrapper}  {
      background-color: ${COLORS.orange_500};
    }
  }

  &:focus-visible {
    outline: none;
  }
`;

export const navigationLinkStyles = css`
  text-decoration: none;
  text-align: center;
`;

export const navigationButtonStyles = css`
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
`;

export const disabledNavigationLinkStyles = css`
  opacity: 0.2;
  pointer-events: none;
  cursor: default;

  &:hover {
    background-color: transparent;
  }

  &.active {
    background-color: transparent;
  }
`;

export const titleStyles = css`
  color: ${COLORS.light_400};
  text-overflow: ellipsis;
  overflow-x: hidden;
  white-space: nowrap;
  width: 100%;
`;

export const MenuList = styled.li`
  width: 90px;
`;

export const StyledNumberIndicator = styled(NumberIndicator)`
  position: absolute;
  top: 4px;
  right: 17px;
`;

export const StyledFlair = styled(Flair)`
  position: absolute;
  top: -4px;
  right: 17px;
  background-color: ${COLORS.dark_700};
  border-radius: 100%;
`;
